/**
 * Single launcher for the Query Store tab, shared by the database context
 * menu, the command palette and the main toolbar. The tab is scoped to one
 * (connection, database); opening the same pair again focuses the existing tab.
 */
import { useWorkspaceStore } from '../core/store/workspaceStore';
import { createDefaultQueryStoreContent, isQueryStoreTab, type TabConnectionInfo } from '../core/types/workspaceTypes';

export type QueryStoreEntryPoint = 'toolbar' | 'command-palette' | 'context-menu';

export const QUERY_STORE_TAB_TITLE = 'Query Store';
export const QUERY_STORE_MENU_LABEL = 'Query Store...';

export function openQueryStoreTab(args: {
  entry: QueryStoreEntryPoint;
  connectionInfo: TabConnectionInfo & { connectionId: string; database: string };
}): string {
  const { connectionInfo } = args;
  const store = useWorkspaceStore.getState();
  const existing = store.tabs.find(
    (tab) =>
      isQueryStoreTab(tab) &&
      tab.connectionInfo?.connectionId === connectionInfo.connectionId &&
      tab.content.database === connectionInfo.database,
  );
  if (existing) {
    store.setActiveTab(existing.id);
    return existing.id;
  }
  return store.addTab({
    title: `${QUERY_STORE_TAB_TITLE}: ${connectionInfo.database}`,
    type: 'query-store',
    connectionInfo,
    content: createDefaultQueryStoreContent(connectionInfo.database),
  });
}
